import { useRef, useState } from 'react';
import { useLocation } from '@remix-run/react';
import { useOnClickOutside } from 'usehooks-ts';

import Icon from '~/components/icon';
import {
  type BaseNavItem,
  type SecondLevelNavItem,
  type ThirdLevelNavItem } from
'~/interfaces/HeaderFooterNavV2';

import { HeaderAllSports } from '../HeaderAllSports';

import styles from './HeaderNavItem.module.css';

interface HeaderNavItemProps {
  variant: 'primary' | 'secondary' | 'tertiary';
}

type HeaderNavItem =
(BaseNavItem & {variant: 'primary';}) |
(SecondLevelNavItem & {variant: 'secondary';}) |
(ThirdLevelNavItem & {variant: 'tertiary';});

type THeaderNavItem = React.FunctionComponent<
  HeaderNavItem & HeaderNavItemProps>;


interface NavLinkProps extends SecondLevelNavItem {
  variant: HeaderNavItem['variant'];
}

interface LinkIconProps {
  icon: SecondLevelNavItem['icon'];
  variant: HeaderNavItem['variant'];
}

const LinkIcon = (props: LinkIconProps) => {
  if (props.variant === 'secondary') {
    const { icon } = props;

    return icon ?
    <Icon className={styles.icon} height={22} icon={icon} width={22} /> :
    null;
  }

  return null;
};

const NavLink = ({ icon, link, name, variant }: NavLinkProps) => {
  return (
    <a className={styles.item} href={link}>
			<LinkIcon icon={icon} variant={variant} />
			{name}
		</a>);

};

interface NavExpandableProps extends SecondLevelNavItem {
  variant: HeaderNavItem['variant'];
}

const NavExpandable = (props: NavExpandableProps) => {
  const ref = useRef(null);
  const { name } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => setIsExpanded((s) => !s);
  const close = () => setIsExpanded(false);

  useOnClickOutside(ref, close);

  return (
    <div ref={ref}>
			<button className={styles.odds} onClick={toggle}>
				<Icon height={14} icon="HamburgerMenu" width={14} />
				{name}
			</button>
			{isExpanded ?
      <HeaderAllSports items={props.items!} onClose={close} /> :
      null}
		</div>);

};

export const HeaderNavItem: THeaderNavItem = (props) => {
  const { link, type, variant } = props;
  const location = useLocation();

  const Component = type === 'ALL_SPORTS_EXPANDABLE' ? NavExpandable : NavLink;

  return (
    <li
      className={`${styles[variant]} ${styles.itemWrapper} ${link === location.pathname ? styles.selected : ''}`}
      key={link}>

			<Component {...props} />
		</li>);

};